export default __webpack_public_path__ + "static/media/tri-via-hub-1.8d1ce3da.png";